import { AuthenticatedHttpClient } from "@/lib/axios";
import {
  ITourProgressResponse,
  OnboardingQnAData,
  Organisation,
} from "@/types/organisation.types";
import { AxiosResponse } from "axios";

export class OrganisationService {
  private http: AuthenticatedHttpClient;

  constructor(httpClient: AuthenticatedHttpClient) {
    this.http = httpClient;
  }

  async getMyOrganisation(): Promise<AxiosResponse<Organisation>> {
    const response = await this.http.get<Organisation>(`/organisation/my`);
    return { data: response } as unknown as AxiosResponse<Organisation>;
  }

  async onboardOrganisation(): Promise<AxiosResponse<Organisation>> {
    const response = await this.http.post<Organisation>(`/onboarding/company`);
    return { data: response } as unknown as AxiosResponse<Organisation>;
  }

  async onboardingQnA({ qna }: { qna: OnboardingQnAData }): Promise<void> {
    await this.http.post(`/onboarding/qna`, {
      qna,
    });
  }

  async fetchOnboardingStatus(): Promise<{
    isOnboardingCompleted: boolean;
  }> {
    const response = await this.http.get(`/onboarding/status`);
    return response as unknown as {
      isOnboardingCompleted: boolean;
    };
  }

  async fetchTourProgress(): Promise<ITourProgressResponse> {
    const response = await this.http.get(`/onboarding/tour-progress`);
    return response as unknown as ITourProgressResponse;
  }
  async updateTourStep({
    step,
    action,
  }: {
    step: number;
    action: "complete" | "skip";
  }): Promise<void> {
    await this.http.patch(`/onboarding/tour-step`, {
      step,
      action,
    });
  }

  async seenWelcomePopup(): Promise<void> {
    await this.http.patch(`/onboarding/seen-welcome-popup`);
  }

  async dismissTour(): Promise<void> {
    await this.http.patch(`/onboarding/dismiss-tour`);
  }

  async pageGuideVisit({
    page,
  }: {
    page: string;
  }): Promise<Record<string, boolean>> {
    const response = await this.http.patch(`/onboarding/page-guide-visit`, {
      page,
    });
    return response as unknown as Record<string, boolean>;
  }
}
